import {twMerge} from '../../../common/twMerge';

export function ContentOverviewBackgroundImage({
  isMobile,
  thumbnailImageSrc,
}: {
  isMobile?: boolean;
  thumbnailImageSrc: string;
}) {
  const mobileGradientColor = 'var(--colors-theme-solid-0)';
  const desktopGradientColor = 'var(--colors-theme-bg-surface-alt)';

  return (
    <div
      className={twMerge(
        'absolute top-0 left-0 h-full w-full overflow-hidden object-cover',
        isMobile
          ? 'bg-static-mono-black'
          : 'bg-[rgb(var(--colors-static-mono-black)_/_30%)]'
      )}
    >
      {thumbnailImageSrc && (
        <img
          alt="썸네일"
          src={thumbnailImageSrc}
          className={twMerge(
            'absolute top-0 left-0 h-full w-full object-cover object-center',
            isMobile ? 'blur-[40px]' : 'blur-[12px]'
          )}
        />
      )}
      <div className="absolute top-0 left-0 h-full w-full bg-[rgb(var(--colors-static-mono-black)_/_10%)]" />
      <div
        className="absolute bottom-0 left-0"
        style={{
          width: '100%',
          height: isMobile ? '100%' : '50%',
          background: isMobile
            ? `linear-gradient(180deg,
            rgb(${mobileGradientColor} / 8%) 0%,
            rgb(${mobileGradientColor} / 16%) 14%,
            rgb(${mobileGradientColor} / 24%) 29%,
            rgb(${mobileGradientColor} / 32%) 43%,
            rgb(${mobileGradientColor} / 46%) 57%,
            rgb(${mobileGradientColor} / 68%) 72%,
            rgb(${mobileGradientColor} / 88%) 86%,
            rgb(${mobileGradientColor}) 100%)`
            : `linear-gradient(180deg,
            rgb(${desktopGradientColor} / 0%) 0%,
            rgb(${desktopGradientColor} / 18%) 20%,
            rgb(${desktopGradientColor} / 42%) 40%,
            rgb(${desktopGradientColor} / 68%) 60%,
            rgb(${desktopGradientColor} / 88%) 80%,
            rgb(${desktopGradientColor}) 100%)`,
        }}
      />
    </div>
  );
}
